// Fork: public status page routes, mounted at '/' on the status host and at
// '/status' in the main app.
import { Route, Routes } from 'react-router-dom'
import { StatusPage } from '../../pages/StatusPage'
import { StatusIncidentPage } from '../../pages/status/StatusIncidentPage'
import { StatusHistoryPage } from '../../pages/status/StatusHistoryPage'
import { StatusBaseContext } from './statusShared'

export function StatusApp({ base }: { base: '' | '/status' }) {
  return (
    <StatusBaseContext.Provider value={base}>
      <Routes>
        <Route index element={<StatusPage />} />
        <Route path="incidents/:id" element={<StatusIncidentPage />} />
        <Route path="history" element={<StatusHistoryPage />} />
        <Route path="*" element={<StatusPage />} />
      </Routes>
    </StatusBaseContext.Provider>
  )
}
